import whatsapp from "./whatsapp";

/**
 * 菜单栏
 */
export const menu = {
  home: "首页",

  robot: "AI 机器人",
  "robot.chat-robot": "对话机器人",
  "robot.create-robot": "创建机器人",
  "robot.external-trigger-log": "外部调用日志",

  "customer-management": "客户管理",
  "customer-management.customer-list": "客户列表",
  "customer-management.customer-base-management": "客户分组管理",
  "customer-management.customer-list.inner": "客户列表",
  "customer-management.customer-list.outer": "客户列表",
  "customer-management.tag": "标签管理",

  operation: "运营管理",
  "operation.operational-task": "运营任务",
  "operation.operational-task.operational-task-list": "运营任务列表",
  "operation.operational-task.create": "创建运营任务",
  "operation.operational-task.edit": "编辑运营任务",
  "operation.operational-task.logs": "运营任务日志记录",
  "operation.operational-task.log": "运营任务日志记录明细",

  "operation.sop": "运营SOP",
  "operation.sop.list": "运营SOP列表",
  "operation.sop.workflow": "SOP流程编排",
  "operation.sop.logs": "SOP运行记录",

  "channel-chat": "渠道会话",
  "channel-chat.channel-account-management.channel-account-list":
    "渠道账号管理",
  "channel-chat.channel-account-management.escrow-management": "托管管理",
  "channel-chat.channel-account-management.default-ai-robot-settings":
    "默认AI机器人设置",
  "channel-chat.channel-account-management.create-channel-team": "新建团队",
  "channel-chat.channel-account-management.edit-channel-team": "编辑团队",
  "channel-chat.channel-account-management.add-channel-account": "添加渠道账号",
  "channel-chat.channel-chat-list": "渠道会话管理",
  "channel-chat.channel-customer-list": "渠道联系人列表",
  "channel-chat.channel-chat-list.wecom-chat": "企业微信会话",
  "channel-chat.channel-chat-list.wechat-chat": "微信会话",
  "channel-chat.channel-chat-list.mail": "邮件会话",
  "channel-chat.channel-chat-list.whatsapp-chat": "WhatsApp会话",
  "channel-chat.channel-customer-list.wecom-contacts": "企业微信通讯录",
  "channel-chat.channel-customer-list.wechat-contacts": "微信通讯录",
  "channel-chat.channel-customer-list.whatsapp-contacts": "WhatsApp通讯录",
  "channel-chat.special-channel-setting": "特殊渠道设置",

  "resource-management": "资源管理",
  "resource-management.my.resource": "我的资源",
  "resource-management.my.order": "我的订单",

  "organization-management": "组织管理",
  "organization-management.message": "组织信息管理",
  "organization-management.user": "授权用户管理",
  "organization-management.list": "组织列表",
  "organization-management.detail": "组织详情",
  "organization-management.upgrade": "组织升级",
  "organization-management.role-permission": "角色权限管理",
  "organization.upgrade": "组织管理",

  "data-panel": "数据面板",

  "auto-outbound": "智能外呼",
  // 菜单栏组件
  // 用户资料
  "profile.account": "账号资料",
  "profile.redirect-offical": "返回官网",
  "profile.logout": "退出登录",

  // 消息中心
  "messages.title": "消息盒子",
  "messages.title.tip": "消息盒子只存放当前最新的 20 条未读消息",
  "messages.empty": "暂无消息",
  "messages.readAll": "全部已读",
  "message.redirect-notification": "前往消息中心",
  "messages.detail.title": "消息详情",
  "messages.detail.action.close": "关闭",
  "messages.detail.action.read": "已读",

  notification: "消息中心",

  "customer-development": "客户开发",
  "customer-development.xiaohongshu": "小红书客户开发",
  "customer-development.xiaohongshu.task": "小红书客户开发任务",

  "whatsapp.connect": "绑定 WhatsApp 账号",
  "whatsapp.connected": "绑定成功",
};

/**
 * 页面
 */
const pages = {
  // 消息中心
  "notification.team": "标题",
  "notification.unread": "未读",
  "notification.read": "已读",
  "notification.table.title": "标题",
  "notification.table.content": "内容",
  "notification.table.time": "时间",
  "notification.table.operation": "操作",
  "notification.table.operation.read": "已读",
  "notification.table.operation.readAll": "全部已读",
  "notification.table.operation.view-detail": "查看详情",
  "notification.table.operation.success": "操作成功",

  // 训练对话
  "training-chat.conversation-document-suffix": "对话",
  "training-chat.robot-training": "机器人训练",
  "training-chat.title": "训练对话",
  "training-chat.robot-base-config": "机器人属性",
  "training-chat.training-record": "训练记录",
  "training-chat.release-text": "训练效果满意，点击上线！",
  "training-chat.release-button": "上线机器人",
  "training-chat.dialog-test-button": "对话测试",
  "training-chat.knowledge-edit-button": "知识内容管理",
  "training-chat.material-edit-button": "素材内容管理",
  "training-chat.add-training": "新建训练",
  "training-chat.good-evaluation": "好评",
  "training-chat.bad-evaluation": "差评",
  "training-chat.total-reply": "总回复",
  "training-chat.knowledge-select": "知识库选择",
  "training-chat.material-select": "素材库选择",
  "training-chat.batch-upload-training-question": "批量上传训练问题",
  "training-chat.batch-uploading": "回答中",
  "training-chat.batch-upload-training-question-tip":
    "请选择一个txt、csv或xlsx文件，其中每行视为一个用户问题；单次最多上传50行内容",
  "training-chat.training-history": "训练历史",
  "training-chat.power-off-title": "当前动能值不足，请先购买动能值",
  "training-chat.template-expired-title": "当前模板已过期，请先购买模板",
  "training-chat.switch-to-main-account-to-buy": "请切换至主账号进行购买",
  "training-chat.buy-now-button": "去购买",
  "training-chat.cancel-button": "取消",
  "training-chat.get-training-record-list-failed": "获取训练记录列表失败",
  "training-chat.delete-training-history-title": "删除训练记录",
  "training-chat.delete-training-history-failed": "删除训练记录失败",
  "training-chat.delete-training-history-success": "删除训练记录成功",
  "training-chat.please-select-training-dialog": "请选择训练的对话",

  // 训练对话-机器人参数表单
  "training-chat.config.input-placeholder": "请输入",
  "training-chat.config.choose-placeholder": "请选择",
  "training-chat.config.tab-title-basic": "基础参数",
  "training-chat.config.tab-title-role-task": "机器人角色任务",
  "training-chat.config.tab-title-workflow": "工作配置",
  "training-chat.config.robot-name": "机器人名称",
  "training-chat.config.robot-name-tip":
    "起名建议：品牌名+核心功能描述+机器人，如 12Times 售后客服机器人、蜗牛保险销售机器人等",
  "training-chat.config.robot-name-placeholder": "赶紧给你的机器人起个名字吧",
  "training-chat.config.robot-description": "机器人功能描述",
  "training-chat.config.robot-description-placeholder": "介绍一下你的机器人吧",
  "training-chat.config.robot-multi-input":
    "是否支持识别客户的图片、语音、视频",
  "training-chat.config.robot-recognizing-phrases": "识别期间等待话术",
  "training-chat.config.robot-recognizing-phrases-placeholder":
    "由于图片、视频和语音的识别需要时间，在等待机器人识别的过程中，你给客户说点什么呢？比如：稍等我看一下哈~",
  "training-chat.config.welcome-word": "欢迎语",
  "training-chat.config.from-validate-error-welcome-word": "请补全欢迎语",
  "training-chat.config.welcome-word-placeholder":
    "主动与客户说的第一句话，一般以提问结尾，也可以发送图片、语音、视频；通常为了使开口目的更聚焦，纯文字是够用的。例如:hello，我是Elsa老师，小朋友有什么英语学习的困扰呢？可以跟我说说我来帮你分析一下~",
  "training-chat.config.add-welcome-word": "添加欢迎语",
  "training-chat.config.interrupt-processing-message-label": "打断处理中消息",
  "training-chat.config.edit-success": "操作成功",
  "training-chat.config.robot-expired": "机器人已过期",
  "training-chat.config.n8n.section-title": "n8n 编排配置",
  "training-chat.config.n8n.webhook-url-label": "Webhook URL",
  "training-chat.config.n8n.webhook-url-placeholder": "请输入 n8n Webhook 地址",
  "training-chat.config.n8n.webhook-url-required": "请输入 n8n Webhook 地址",
  "training-chat.config.n8n.webhook-url-invalid": "请输入合法的 URL 地址",
  "training-chat.config.n8n.tip":
    "工作流需先在 n8n 侧创建并激活，否则机器人无法正常回复",

  // 对话机器人
  "robot.chat-robot.title": "对话机器人",
  "robot.chat-robot.search": "搜索...",
  "robot.chat-robot.update-time": "修改时间",
  "robot.chat-robot.sort-by": "排序方式",
  "robot.chat-robot.sort-type": "排序类型",
  "robot.chat-robot.create-date": "创建日期",
  "robot.chat-robot.update-date": "更新日期",
  "robot.chat-robot.sort-name": "名称排序",
  "robot.chat-robot.sort.time.asc": "时间升序",
  "robot.chat-robot.sort.time.desc": "时间降序",
  "robot.chat-robot.no-robot": "暂无机器人，",
  "robot.chat-robot.go-create": "去创建",
  "robot.chat-robot.delete": "删除机器人",
  "robot.chat-robot.all-template": "全部模板",
  "robot.chat-robot.delete.tip":
    "删除后，将有{count}个会话取消托管，是否确认删除？",
  "robot.chat-robot.delete.success": "删除成功",
  "robot.chat-robot.delete.confirm": "确认删除",
  "robot.chat-robot.delete.cancel": "取消，不删除",
  "robot.chat-robot.create-new-robot": "创建新机器人",
  "robot.chat-robot.create-new-robot-desc": "创建新机器人，可以快速开始对话",

  // 付费相关页面
  // 订单概览
  "resource.order.title": "我的订单",
  "resource.order.table.order-id": "订单号",
  "resource.order.table.goods-name": "商品",
  "resource.order.table.consumption-type": "订单类型",
  "resource.order.table.consumption-type.order-type.newly-purchased": "新购",
  "resource.order.table.consumption-type.order-type.renew": "续费",
  "resource.order.table.consumption-type.order-type.upgrade": "新购",
  "resource.order.table.consumption-type.order-type.upgrade-template": "升级",
  "resource.order.table.consumption-type.order-type.member": "版本订阅",
  "resource.order.table.consumption-type.order-type.renew-member": "续费订阅",
  "resource.order.table.consumption-type.order-type.upgrade-member": "升级订阅",
  "resource.order.table.consumption-type.order-type.auto-renew-member":
    "自动续费",
  "resource.order.table.create-time": "创建时间",
  "resource.order.table.pay-time": "支付/开通时间",
  "resource.order.table.order-status": "订单状态",
  "resource.order.table.pay-amount": "应付金额",
  "resource.order.table.operation.view-detail": "详情",
  "resource.order.table.operation.pay": "支付",

  // 订单详情
  "resource.order.detail.title": "订单详情",
  "resource.order.detail.subtitle.information": "基本信息",
  "resource.order.detail.subtitle.information.order-id": "订单号：",
  "resource.order.detail.subtitle.information.consumption-type": "订单类型：",
  "resource.order.detail.subtitle.information.create-time": "创建时间：",
  "resource.order.detail.subtitle.information.pay-time": "支付/开通时间：",
  "resource.order.detail.subtitle.information.order-status": "订单状态：",
  "resource.order.detail.subtitle.information.order-status.pending": "待支付",
  "resource.order.detail.subtitle.information.order-status.paid": "已支付",
  "resource.order.detail.subtitle.information.order-status.cancelled": "已作废",
  "resource.order.detail.subtitle.information.amount": "订单金额：",
  "resource.order.detail.subtitle.information.username": "用户名：",
  "resource.order.detail.table.title": "订单明细",
  "resource.order.detail.table.goods-name": "商品名称",
  "resource.order.detail.table.nums": "数量",
  "resource.order.detail.table.total-amount": "官网价（元）",
  "resource.order.detail.table.discount-amount": "优惠金额（元）",
  "resource.order.detail.table.need-to-pay-amount": "应付金额（元）",
  "resource.order.detail.table.action.pay": "立即支付",

  // 月账单概览
  "resource.my.monthly-bill.title": "月账单概览",
  "resource.my.monthly-bill.table.bill-month": "账期",
  "resource.my.monthly-bill.table.consume-amount": "消费金额（元）",
  "resource.my.monthly-bill.table.settle-amount": "已还款金额（元）",
  "resource.my.monthly-bill.table.arrears-amount": "欠款金额（元）",
  "resource.my.monthly-bill.table.operation.view-detail": "查看详情",

  // 月账单详情
  "resource.my.monthly-bill.detail.title": "月账单详情",
  "resource.my.monthly-bill.detail.subtitle.information": "账单基本信息",
  "resource.my.monthly-bill.detail.subtitle.information.bill-month": "账期：",
  "resource.my.monthly-bill.detail.table.title": "账单流水",
  "resource.my.monthly-bill.detail.table.id": "账单号",
  "resource.my.monthly-bill.detail.table.bill-detail": "商品",
  "resource.my.monthly-bill.detail.table.consume-time": "消费时间",
  "resource.my.monthly-bill.detail.table.bill-type": "账单类型",
  "resource.my.monthly-bill.detail.table.payable-amount": "应付金额（元）",
  "resource.my.monthly-bill.detail.table.paid-amount": "已付金额（元）",
  "resource.my.monthly-bill.detail.table.arrears-amount": "欠款金额（元）",
  "resource.my.monthly-bill.detail.table.bill-status": "支付状态",
  "resource.my.monthly-bill.detail.table.bill-status.wait-billing": "出账中",
  "resource.my.monthly-bill.detail.table.bill-status.wait-pay": "未结清",
  "resource.my.monthly-bill.detail.table.bill-status.done": "已结清",
  "resource.my.monthly-bill.detail.table.bill-status.tip":
    "此账单尚未结清，请您向账户充值足够金额，充值完成后系统将自动进行扣款",
  "resource.my.monthly-bill.detail.table.order-id": "关联订单号",

  // 收支明细
  "resource.transaction-detail.title": "收支明细",
  "resource.transaction-detail.table.pay-no": "流水号",
  "resource.transaction-detail.table.pay-time": "交易时间",
  "resource.transaction-detail.table.trans-type": "收支类型",
  "resource.transaction-detail.table.trans-type.income": "收入",
  "resource.transaction-detail.table.trans-type.expenditure": "支出",
  "resource.transaction-detail.table.change-type": "交易类型",
  "resource.transaction-detail.table.change-type.consumption": "消费",
  "resource.transaction-detail.table.change-type.recharge": "充值",
  "resource.transaction-detail.table.pay-type": "交易渠道",
  "resource.transaction-detail.table.pay-type.balance": "用户余额",
  "resource.transaction-detail.table.pay-type.offline-bank-card": "线下银行卡",
  "resource.transaction-detail.table.pay-type.wechat": "微信",
  "resource.transaction-detail.table.pay-type.alipay": "支付宝",
  "resource.transaction-detail.table.pay-amount": "交易金额",
  "resource.transaction-detail.table.gift-amount": "赠送金额",
  "resource.transaction-detail.table.total-balance": "总余额",
  "resource.transaction-detail.table.cash-balance": "充值余额",
  "resource.transaction-detail.table.gift-balance": "赠送余额",
  "resource.transaction-detail.table.bill-time": "账期",
  "resource.transaction-detail.table.username": "用户名",
  "resource.transaction-detail.table.third-pay-no": "第三方流水号",
  "resource.transaction-detail.table.bill-id": "账单号",
  "resource.transaction-detail.table.pay-status": "状态",
  "resource.transaction-detail.table.pay-status.completed": "已生效",
  "resource.transaction-detail.table.pay-status.pending": "审核中",

  // 标签管理
  "customer-management.tag.title": "标签管理",
  "customer-management.tag.action.label.sync-tags-from-wecom": "从企微同步标签",
  "customer-management.tag.action.add-tag-group": "添加标签组",
  "customer-management.tag.message.config-assist-in-the-development":
    "请先在特殊渠道配置中设置代开发应用",
  "customer-management.tag.message.config-sync-tags-from-wecom-success":
    "更改从企业微信同步标签设置成功",
  "customer-management.tag.message.update-tag-group-sort-success":
    "更新标签组排序成功",

  // WhatsApp
  whatsapp,
};

const common = {
  confirm: "确认",
  cancel: "取消",
  export: "导出",
  "table.operation": "操作",
  "history.back": "返回",
};

/**
 * 通用组件
 */
const components = {
  // 托管失败弹窗
  "escrow-fail-modal.title": "托管失败",
  "escrow-fail-modal.upgrade.description1":
    "单账号版机器人只能托管一个账号下的会话",
  "escrow-fail-modal.upgrade.description2":
    "若想托管多个账号，请升级到多账号版",
  "escrow-fail-modal.buy.description1":
    "免费试用的机器人为单账号版，只能托管一个账号下的会话",
  "escrow-fail-modal.buy.description2": "若想托管多个账号，请购买多账号版",
  "escrow-fail-modal.action.upgrade": "升级机器人",
  "escrow-fail-modal.action.buy": "购买机器人",

  // 付费系统共用文案
  "trading-system.common.selected": "已选 {num} 个，合计",
  "trading-system.common.agreement": "我已阅读并同意",
  "trading-system.common.agreement.policy": "服务支付协议",
  "trading-system.common.message.warn-check-policy": "请阅读并同意协议",
  "trading-system.common.text.invoice-and-contract": "发票和合同",
  "trading-system.common.text.invoice-and-contract.description":
    "订单完成后,可以联系客服申请开发票和签订合同",
  "trading-system.common.monetary.symbol": "¥",
  "trading-system.common.price.unit.month": "月",
  "trading-system.common.price.unit.year": "年",

  // 选择机器人模块
  "trading-system.module.select-template.disable.tip.single":
    "该机器人已购买单账号版，无法直接购买多账号版，请进入“我的资源”页面，补差价升级该机器人",
  "trading-system.module.select-template.disable.tip.multiple":
    "该机器人已购买多账号版，无法购买单账号版，机器人过期后才可购买单账号版本",

  // 升级机器人弹窗
  "upgrade-robot-modal.title": "升级机器人",
  "upgrade-robot-modal.result.title": "费用说明：",
  "upgrade-robot-modal.result.description":
    "升级时将减免单账号版机器人的费用，您只需要补差价即可完成升级",
  "upgrade-robot-modal.single.title": "单账号版",
  "upgrade-robot-modal.single.description": "可托管一个账号的会话",
  "upgrade-robot-modal.multiple.title": "多账号版",
  "upgrade-robot-modal.multiple.description": "可托管多个账号的会话",
  "upgrade-robot-modal.form.item.select-robot": "选择机器人模板",
  "upgrade-robot-modal.action.upgrade": "立即升级",
  "upgrade-robot-modal.select.title": "选择升级的机器人",
  "upgrade-robot-modal.success-modal.title": "升级成功",
  "upgrade-robot-modal.success-modal.description": "机器人可以托管多个账号啦～",
  "upgrade-robot-modal.success-modal.action.close": "{seconds} 秒后收起",

  // 购买/续费机器人
  "buy-or-renew-robot-modal.title.buy": "购买机器人",
  "buy-or-renew-robot-modal.title.renew": "续费机器人",
  "buy-or-renew-robot-modal.form.item.select-version": "选择版本",
  "buy-or-renew-robot-modal.form.item.select-template": "选择机器人模板",
  "buy-or-renew-robot-modal.form.item.select-duration": "购买时长",
  "buy-or-renew-robot-modal.action.buy": "立即下单",

  // 降级机器人弹窗提醒
  "downgrade-robot-warning-modal.title": "机器人降级提醒",
  "downgrade-robot-warning-modal.description1":
    "您选择的 {count} 个模板上次购买了多账号版",
  "downgrade-robot-warning-modal.description2": "本次是否降为单账号版？",
  "downgrade-robot-warning-modal.important1":
    "降级后，对应的机器人托管的账号将全部取消托管",
  "downgrade-robot-warning-modal.important2": "您需要重新托管",
  "downgrade-robot-warning-modal.action.cancel": "我再看看",
  "downgrade-robot-warning-modal.action.ok": "继续购买",

  // 购买动能值弹窗
  "buy-power-modal.title": "购买动能值",
  "buy-power-modal.payment-amount": "支付金额",
  "buy-power-modal.action.buy": "立即下单",

  // 购买/续费席位
  "buy-or-renew-seat-modal.title.buy": "购买席位",
  "buy-or-renew-seat-modal.title.renew": "续费席位",
  "buy-or-renew-seat-modal.action.buy": "立即下单",
  "buy-or-renew-seat-modal.form.item.buy.seat-count": "席位数量",
  "buy-or-renew-seat-modal.form.item.buy.duration": "购买时长",
  "buy-or-renew-seat-modal.form.item.renew.duration": "续费时长",
  "buy-or-renew-seat-modal.form.item.renew.select-seat": "勾选续费席位",
  "buy-or-renew-seat-modal.form.item.buy.seat-type": "渠道类型",

  // 升级正式版弹窗
  "upgrade-modal.title": "升级正式版",
  "upgrade-modal.slogan": "实现团队资源的内部共享与统一管理",
  "upgrade-modal.subtitle.features-compare": "功能对比",
  "upgrade-modal.subtitle.features-compare.col.content": "功能内容",
  "upgrade-modal.subtitle.features-compare.col.content.robot": "机器人",
  "upgrade-modal.subtitle.features-compare.col.content.chat": "聊天软件接入",
  "upgrade-modal.subtitle.features-compare.col.content.collaboration":
    "团队协作",
  "upgrade-modal.subtitle.features-compare.col.content.ram": "建立授权账号",
  "upgrade-modal.subtitle.features-compare.col.content.power-fee": "动能值费用",
  "upgrade-modal.subtitle.features-compare.col.personal.give-away-power-fee":
    "赠送1000点动能值",
  "upgrade-modal.subtitle.features-compare.col.personal": "试用版",
  "upgrade-modal.subtitle.features-compare.col.personal.trial-for-serven-days":
    "免费试用7天",
  "upgrade-modal.subtitle.features-compare.col.organizational": "正式版",
  "upgrade-modal.subtitle.features-compare.col.organizational.power-fee.description":
    "每日结算",
  "upgrade-modal.subtitle.features-compare.col.organizational.power-fee.fee":
    "（0.1 元/点）",
  "upgrade-modal.subtitle.features-compare.col.organizational.power-fee.tip":
    "升级至正式版后，动能值费用将调整为每天自动结算模式；每天中午12点将自动扣除前一天的动能值费用，费用标准为 0.1 元/点。",
  "upgrade-modal.subtitle.price-description": "费用说明",
  "upgrade-modal.subtitle.price-description.first-line.recharge": "充值",
  "upgrade-modal.subtitle.price-description.first-line.recharge-fee": "3000 元",
  "upgrade-modal.subtitle.price-description.first-line.rest":
    "到 12Times 账户，即可升级为正式版",
  "upgrade-modal.subtitle.price-description.second-line":
    "升级为正式版后，立刻结束试用期，并续费一个月的固定渠道账号。",
  "upgrade-modal.subtitle.price-description.third-line":
    "其中 ¥100为固定渠道账号费用，¥1900为可用余额，可用于购买各种服务，而 ¥1000 则作为保证金，注销账户时将退还",
  "upgrade-modal.action.upgrade": "立即下单",

  // 检查预上线失败
  "check-online-fail-modal.description1":
    "您未购买机器人，无法使用免费赠送的席位",
  "check-online-fail-modal.description2": "请去购买机器人或购买更多席位吧~",
  "check-online-fail-modal.action.buy-robot": "购买机器人",
  "check-online-fail-modal.action.buy-seat": "购买席位",

  // 从 flow 创建机器人弹窗
  "create-robot-with-flow-select-modal.title": "创建机器人",
  "create-robot-with-flow-select-modal.information.title": "自定义机器人信息",
  "create-robot-with-flow-select-modal.information.form.name.label":
    "机器人名称",
  "create-robot-with-flow-select-modal.information.form.name.tooltip":
    "起名建议：品牌名+核心功能描述+机器人，如 12Times 售后客服机器人、蜗牛保险销售机器人等",
  "create-robot-with-flow-select-modal.information.form.name.placeholder":
    "赶紧给你的机器人起个名字吧",
  "create-robot-with-flow-select-modal.information.form.description.label":
    "机器人功能描述",
  "create-robot-with-flow-select-modal.information.form.description.placeholder":
    "介绍一下你的机器人吧",
  "create-robot-with-flow-select-modal.options.template.name": "从模板创建",
  "create-robot-with-flow-select-modal.options.template.description":
    "使用预制模板进行创建",
  "create-robot-with-flow-select-modal.options.flow.name": "从编排创建",
  "create-robot-with-flow-select-modal.options.flow.description":
    "从 0 开始编排创建",
  "create-robot-with-flow-select-modal.options.n8n.name": "从 n8n 编排创建",
  "create-robot-with-flow-select-modal.options.n8n.description":
    "接入已有 n8n 工作流",
  "create-robot-with-flow-select-modal.information.n8n.title": "n8n 机器人信息",
  "create-robot-with-flow-select-modal.information.form.webhookUrl.label":
    "Webhook URL",
  "create-robot-with-flow-select-modal.information.form.webhookUrl.placeholder":
    "请输入 n8n Webhook 地址",

  "edit-n8n-robot-modal.title": "n8n设定",
  "edit-n8n-robot-modal.success": "保存成功",
  "edit-n8n-robot-modal.welcomeWord.label": "欢迎语",
  "edit-n8n-robot-modal.welcomeWord.placeholder":
    "检测到「你已添加了XXX，可以开始聊天了」时发送的纯文本，留空则本轮直接进入 n8n 工作流",
  "edit-n8n-robot-modal.welcomeWord.tooltip":
    "检测到「你已添加了XXX，可以开始聊天了」时发送。",
  "edit-n8n-robot-modal.addFriendTrigger.label": "加好友时触发编排",
  "edit-n8n-robot-modal.addFriendTrigger.lead":
    "打开后，加好友时产生的第一条消息会送入 n8n 编排（内容含「可以开始聊天了」或「以上是打招呼的消息」等固定文案，企微只认「可以开始聊天了」）；是否回复、回复什么由 n8n 工作流自行判断。",
  "edit-n8n-robot-modal.addFriendTrigger.warning":
    "打开后欢迎语输入框会收起，平台不再直发已保存的欢迎语，加好友产生的第一条单聊消息改送 n8n 编排。欢迎语文案仍保留，关闭开关后输入框重新出现，并恢复由平台直发。若工作流未配置相应分支，客户加好友后将收不到工作流回复。",
  "edit-n8n-robot-modal.addFriendTrigger.intro":
    "可能送入编排的内容与次数如下：",
  "edit-n8n-robot-modal.addFriendTrigger.wechatTitle": "个微（微信）：",
  "edit-n8n-robot-modal.addFriendTrigger.wecomTitle": "企微：",
  "edit-n8n-robot-modal.addFriendTrigger.col.scene": "加好友场景",
  "edit-n8n-robot-modal.addFriendTrigger.col.message": "会送入编排的消息",
  "edit-n8n-robot-modal.addFriendTrigger.col.count": "送入次数",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.1.scene": "你加别人，对方通过",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.1.message":
    "「以上是打招呼的消息」或「我通过了你的朋友验证请求，现在我们可以开始聊天了」",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.1.count": "1 次",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.2.scene":
    "别人加你，且对方填了招呼语",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.2.message":
    "「你已添加了××，以上是打招呼的消息。」送入 1 次；对方的招呼语（如「我是缘」）可能作为普通消息再送 1 次，与微信消息的到达先后顺序有关，不保证每次都送入",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.2.count": "1~2 次",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.3.scene":
    "对方未填招呼语直接通过，或被对方加进通讯录",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.3.message":
    "「你已添加了××，现在可以开始聊天了。」等系统文案",
  "edit-n8n-robot-modal.addFriendTrigger.wechat.3.count": "1 次",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.1.scene": "微信用户加你的企微",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.1.message":
    "「你已添加了××，现在可以开始聊天了。」或「我已经添加了你，现在我们可以开始聊天了。」",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.1.count": "1 次",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.2.scene": "同事互加",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.2.message":
    "「你已添加了××，现在可以开始聊天了。」",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.2.count": "1 次",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.3.scene": "你加别人，对方通过",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.3.message":
    "「我通过了你的联系人验证请求，现在我们可以开始聊天了」",
  "edit-n8n-robot-modal.addFriendTrigger.wecom.3.count": "1 次",
  "edit-n8n-robot-modal.addFriendTrigger.footer":
    "补充：群聊邀请不送入编排。开关打开期间，平台也不再为群邀请直发已保存的欢迎语；关闭开关后恢复。n8n 工作流判断加好友场景可认「可以开始聊天了」或「以上是打招呼的消息」两句固定文案。",

  "n8n-workflow-bind.webhook.post-only-hint": "仅支持 POST webhook",
};

export default {
  menu,
  pages,
  common,
  components,
};
